import find from 'lodash-es/find'
import isUndefined from 'lodash-es/isUndefined'
import * as Yup from 'yup'

/** Yup message key; must stay in sync with `Error.password.weak` in locale files */
export const PASSWORD_WEAK_ERROR = 'password.weak'

export const checkPasswordWeakness = (value = '') => {
  const errors = {
    length: value.length > 7,
    lowercase: /.*[a-z]+.*/.test(value),
    uppercase: /.*[A-Z]+.*/.test(value),
    numeric: /.*\d+.*/.test(value),
    special: /.*[!@#$%^&*].*/.test(value),
  }
  const isWeak = !isUndefined(find(errors, (e) => !e))

  return { isWeak, errors }
}

Yup.addMethod(Yup.string, 'password', function () {
  return this.test({
    test: (value) => (value ? !checkPasswordWeakness(value).isWeak : true),
    message: PASSWORD_WEAK_ERROR,
  })
})

declare module 'yup' {
  interface StringSchema {
    password(): Yup.StringSchema
  }
}
